module.exports = __webpack_public_path__ + "static/media/rain.04715ce8.svg";